import { EmptyState } from '@myhome/ui/patterns/empty-state';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_shell/categories-areas')({
  component: Page,
});

function Page() {
  return (
    <div className="flex flex-col gap-5">
      <h1 className="font-heading text-headline font-semibold text-navy-900">Categories and areas</h1>
      <EmptyState
        title="Categories and areas"
        description="Trade categories and Gauteng service areas arrive with the catalog feature."
      />
    </div>
  );
}
